export const DISPLAY_FONTS = [
    { font: 'Abril Fatface', weights: [400] },
    { font: 'Alfa Slab One', weights: [400] },
    { font: 'Amatic SC', weights: [400, 700] },
    { font: 'Anton', weights: [400] },
    { font: 'Antonio', weights: [200, 300, 400, 500, 600, 700] },
    { font: 'Audiowide', weights: [400] },
    { font: 'Arvo', weights: [400, 700] },
    { font: 'Bangers', weights: [400] },
    { font: 'Big Shoulders Text', weights: [400] },
    { font: 'Bebas Neue', weights: [400] },
    { font: 'Bungee', weights: [400] },
    { font: 'Caprasimo', weights: [400] },
    { font: 'Carter One', weights: [400] },
    { font: 'Caveat', weights: [400, 500, 600, 700] },
    { font: 'Changa One', weights: [400] },
    { font: 'Chewy', weights: [400] },
    { font: 'Cinzel', weights: [400, 500, 600, 700, 800, 900] },
    { font: 'Cormorant Garamond', weights: [300, 400, 500, 600, 700] },
    { font: 'Dancing Script', weights: [400, 500, 600, 700] },
    { font: 'Days One', weights: [400] },
    { font: 'Freckle Face', weights: [400] },
    { font: 'Fredericka the Great', weights: [400] },
    { font: 'Fugaz One', weights: [400] },
    { font: 'Gorditas', weights: [400, 700] },
    { font: 'Graduate', weights: [400, 700] },
    { font: 'Homemade Apple', weights: [400] },
    { font: 'Inter', weights: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { font: 'Karla', weights: [200, 300, 400, 500, 600, 700, 800] },
    { font: 'League Gothic', weights: [400] },
    {
        font: 'League Spartan',
        weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    },
    { font: 'Lexend', weights: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { font: 'Libre Baskerville', weights: [400, 700] },
    { font: 'Lilita One', weights: [400] },
    { font: 'Lobster', weights: [400] },
    { font: 'Lora', weights: [400, 500, 600, 700] },
    { font: 'Love Ya Like A Sister', weights: [400] },
    { font: 'Luckiest Guy', weights: [400] },
    { font: 'Lustria', weights: [400] },
    { font: 'Merriweather', weights: [300, 400, 500, 600, 700, 800, 900] },
    { font: 'McLaren', weights: [400] },
    {
        font: 'Montagu Slab',
        weights: [100, 200, 300, 400, 500, 600, 700],
    },
    {
        font: 'Montserrat',
        weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    },
    { font: 'Nixie One', weights: [400] },
    { font: 'Nunito', weights: [200, 300, 400, 500, 600, 700, 800, 900, 1000] },
    { font: 'Open Sans', weights: [300, 400, 500, 600, 700, 800] },
    { font: 'Oswald', weights: [200, 300, 400, 500, 600, 700] },
    { font: 'Oxygen', weights: [300, 400, 700] },
    { font: 'Pacifico', weights: [400] },
    { font: 'Parisienne', weights: [400] },
    { font: 'Paytone One', weights: [400] },
    { font: 'Petit Formal Script', weights: [400] },
    { font: 'Philosopher', weights: [400, 700] },
    { font: 'Playfair Display', weights: [400, 500, 600, 700, 800, 900] },
    { font: 'Proza Libre', weights: [400, 500, 600, 700, 800] },
    { font: 'Prosto One', weights: [400] },
    { font: 'Poppins', weights: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    { font: 'Quicksand', weights: [300, 400, 500, 600, 700] },
    { font: 'Racing Sans One', weights: [400] },
    { font: 'Rajdhani', weights: [300, 400, 500, 600, 700] },
    { font: 'Raleway', weights: [100, 200, 300, 400, 500, 600, 700, 800, 900] },
    {
        font: 'Red Hat Display',
        weights: [300, 400, 500, 600, 700, 800, 900],
    },
    {
        font: 'Roboto Condensed',
        weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    },
    {
        font: 'Roboto Slab',
        weights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
    },
    { font: 'Rubik Dirt', weights: [400] },
    { font: 'Rum Raisin', weights: [400] },
    { font: 'Sacramento', weights: [400] },
    { font: 'Sora', weights: [100, 200, 300, 400, 500, 600, 700, 800] },
    {
        font: 'Source Sans 3',
        weights: [200, 300, 400, 500, 600, 700, 800, 900],
    },
    { font: 'Space Grotesk', weights: [300, 400, 500, 600, 700] },
    { font: 'Special Elite', weights: [400] },
    { font: 'Sriracha', weights: [400] },
    { font: 'Suez One', weights: [400] },
    { font: 'Syncopate', weights: [400, 700] },
    { font: 'Ubuntu', weights: [300, 400, 500, 600, 700] },
    { font: 'Work Sans', weights: [100, 200, 300, 400, 500, 600, 700, 800] },
    { font: 'Yeseva One', weights: [400] },
];

export const TEXT_FONTS = [
    { font: 'Andika', weights: [400, 700] },
    { font: 'Archivo', weights: [200, 300, 400, 500, 600] },
    { font: 'Crimson Text', weights: [400, 600, 700] },
    { font: 'EB Garamond', weights: [400, 500, 600] },
    { font: 'Inconsolata', weights: [300, 400, 500, 600] },
    { font: 'Inter', weights: [200, 300, 400, 500, 600] },
    { font: 'Josefin Sans', weights: [200, 300, 400, 500, 600] },
    { font: 'Karla', weights: [200, 300, 400, 500, 600] },
    { font: 'Lato', weights: [400, 500, 600] },
    {
        font: 'League Spartan',
        weights: [100, 200, 300, 400, 500],
    },
    { font: 'Libre Baskerville', weights: [400, 700] },
    { font: 'Literata', weights: [200, 300, 400, 500, 600, 700] },
    { font: 'Merriweather', weights: [300, 400, 500, 600] },
    {
        font: 'Montagu Slab',
        weights: [200, 300, 400, 500, 600, 700],
    },
    { font: 'Montserrat', weights: [300, 400, 500, 600] },
    { font: 'Nunito Sans', weights: [200, 300, 400, 500, 600] },
    { font: 'Open Sans', weights: [300, 400, 500, 600] },
    { font: 'Poppins', weights: [200, 300, 400, 500, 600] },
    { font: 'Proza Libre', weights: [400, 500, 600] },
    { font: 'Quicksand', weights: [300, 400, 500, 600] },
    { font: 'Rajdhani', weights: [300, 400, 500, 600, 700] },
    { font: 'Raleway', weights: [300, 400, 500, 600] },
    {
        font: 'Red Hat Display',
        weights: [300, 400, 500, 600, 700, 800, 900],
    },
    { font: 'Roboto', weights: [200, 300, 400, 500, 600] },
    { font: 'Rubik', weights: [300, 400, 500, 600] },
    { font: 'Source Sans 3', weights: [200, 300, 400, 500, 600] },
    { font: 'Ubuntu', weights: [300, 400, 500, 600] },
    { font: 'Varela Round', weights: [400] },
];

export const sanitizeFontFamily = (value) =>
    String(value || '')
        .replace(/["'`<>]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

export const normalizeGoogleFontWeights = (weights = []) =>
    [
        ...new Set(
            weights.map((weight) => Number(weight)).filter(Number.isFinite)
        ),
    ]
        .map((weight) => Math.round(weight))
        .filter((weight) => weight >= 100 && weight <= 1000)
        .sort((a, b) => a - b);

const ALL_GOOGLE_FONTS = [...DISPLAY_FONTS];

TEXT_FONTS.forEach((font) => {
    if (!ALL_GOOGLE_FONTS.find((entry) => entry.font === font.font)) {
        ALL_GOOGLE_FONTS.push(font);
    }
});

const FONT_WEIGHTS_BY_FAMILY = new Map(
    ALL_GOOGLE_FONTS.map((entry) => [
        sanitizeFontFamily(entry.font).toLowerCase(),
        normalizeGoogleFontWeights(entry.weights),
    ])
);

export const getKnownGoogleFontWeights = (family) =>
    FONT_WEIGHTS_BY_FAMILY.get(sanitizeFontFamily(family).toLowerCase()) || [];

export const getSiteFontRequestWeights = ({
    family,
    selectedWeight,
    fallbackWeights = [],
}) => {
    const knownWeights = getKnownGoogleFontWeights(family);
    const requestedWeights = normalizeGoogleFontWeights([
        selectedWeight,
        ...fallbackWeights,
    ]);

    if (knownWeights.length) {
        const matchedWeights = knownWeights.filter((weight) =>
            requestedWeights.includes(weight)
        );
        if (matchedWeights.length) return matchedWeights;
        return requestedWeights.length
            ? [requestedWeights[0]]
            : [knownWeights[0]];
    }

    if (requestedWeights.length) {
        return [requestedWeights[0]];
    }

    return [400];
};
